export default "__VITE_ASSET__CWjajq2C__"